import React from 'react';
import PropTypes from 'prop-types';
import styled from '@bd/bdui-styles/emotion';

function PageSection({ heading, children, className }) {
  return (
    <div className={className}>
      <div className="PageSection_container container">
        <h3 className="PageSection_heading">{heading}</h3>
        <div>
          {children}
        </div>
      </div>
    </div>
  );
}

PageSection.propTypes = {
  className: PropTypes.string.isRequired,
  heading: PropTypes.node,
  children: PropTypes.node.isRequired,
};

PageSection.defaultProps = {
  heading: undefined,
};

export default styled(PageSection) `
  ${props => (!props.fullwidth ? '' : `
    .PageSection_container {
      max-width: 100% !important;
    }
  `)}
  .PageSection_container {
    padding-top: 30px;
    padding-bottom: 30px;
    @media (min-width: 992px) {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/PageSection.js